import { render, staticRenderFns } from "./EmployeeDashboard.vue?vue&type=template&id=32c85189&scoped=true"
import script from "./EmployeeDashboard.vue?vue&type=script&lang=js"
export * from "./EmployeeDashboard.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDashboard.vue?vue&type=style&index=0&id=32c85189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c85189",
  null
  
)

export default component.exports